import { jsx as _jsx } from "react/jsx-runtime";
import { unpack_validation } from 'z3k-parser/validation/types';
import { DragDropDrawer } from '../utils/drag-drop-drawer/component';
import { RouteNaming, Z3kSecondRoutes } from 'z3k-settings/routes/type';
import { Z3kDragDropContainer } from '../utils/drag-drop-drawer/container';
import { removeNulls } from 'utils';
export function NotificationsList() {
    const childrenItem = (selected_item_id) => {
        return (_jsx(DragDropDrawer, { z3k_name: "notifications", name: RouteNaming[Z3kSecondRoutes.notifications], help_id: "notifications", item_url: Z3kSecondRoutes.notifications, enableDnd: true, selected_item_id: selected_item_id }));
    };
    const customButtons = [Z3kSecondRoutes.trusted_numbers];
    const findId = (item_key, item_id, findInConfig) => {
        return ((!item_id || !findInConfig) && item_key != Z3kSecondRoutes.trusted_numbers);
    };
    return (_jsx(Z3kDragDropContainer, { childrenItem: childrenItem, customButtons: customButtons, findId: findId }));
}
NotificationsList.isError = (validation_result, is_service_view, spec) => {
    const fields = removeNulls([
        'notifications',
        spec.show_simple_notification_tab ? 'users' : null,
    ]);
    return fields.reduce((prev, current) => prev || !!unpack_validation(validation_result, current), false);
};
NotificationsList.isWarning = NotificationsList.isError;
NotificationsList.isShown = (is_service_view, config, spec, is_staff, is_climatic) => !is_climatic &&
    spec.has_notifications &&
    (spec.has_service_mode ? is_service_view : true);
